import React from 'react';

const ShareButton = ({ className = 'btn btn-outline-secondary btn-sm btn-block' }) => {
  // Funkcja, która otwiera nowe okno z Facebook Sharerem
  const share = () => {
    const currentUrl = encodeURIComponent(window.location.href);
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`;
    window.open(facebookUrl, 'facebook-share-dialog', 'width=800,height=600');
  };

  return (
    <button className={className} onClick={share}>Udostępnij na Facebooku</button>
  );
};

export default ShareButton;
